let ws: WebSocket | null = null;

export function connectWebSocket(onData: (data: any) => void, localData?: any) {
  ws = new window.WebSocket("ws://localhost:8081");
  ws.onmessage = (event) => {
    const data = JSON.parse(event.data);
    if (Array.isArray(data) && data.length > 0) {
      onData(data);
    } else if (localData && Array.isArray(localData) && localData.length > 0) {
      // Server sent empty data, send local data to server
      ws?.send(JSON.stringify(localData));
      onData(localData);
    }
  };
}

export function broadcastChange(data: any) {
  if (ws && ws.readyState === ws.OPEN) {
    ws.send(JSON.stringify(data));
  }
} 